import { render, staticRenderFns } from "./UpdateItemButton.vue?vue&type=template&id=2b148633&scoped=true&"
import script from "./UpdateItemButton.vue?vue&type=script&lang=js&"
export * from "./UpdateItemButton.vue?vue&type=script&lang=js&"
import style0 from "./UpdateItemButton.vue?vue&type=style&index=0&id=2b148633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b148633",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b148633')) {
      api.createRecord('2b148633', component.options)
    } else {
      api.reload('2b148633', component.options)
    }
    module.hot.accept("./UpdateItemButton.vue?vue&type=template&id=2b148633&scoped=true&", function () {
      api.rerender('2b148633', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Inventory/buttons/UpdateItemButton.vue"
export default component.exports